import React, { CSSProperties } from "react";

import { SelfServeNode } from "../types";

import { IssueTopicCard } from "./IssueTopicCard/IssueTopicCard";

interface IProps {
  otherNode: SelfServeNode | undefined;
  selectedNode: SelfServeNode | undefined;
  parentNode: SelfServeNode | undefined;
  onClick: (node: SelfServeNode) => void;
  style?: CSSProperties;
}

const isL1 = (parentNode: SelfServeNode | undefined) => {
  return parentNode?.level === 0;
};

const hideL1OtherNode = (parentNode: SelfServeNode | undefined) => {
  return isL1(parentNode);
};

const hideFaireProgramsOtherNode = (parentNode: SelfServeNode | undefined) => {
  return parentNode?.id === "FairePrograms";
};

const hideVerifyAccountOtherNode = (parentNode: SelfServeNode | undefined) => {
  return parentNode?.id === "VerifyAccount";
};

const hideSettingsOtherNode = (parentNode: SelfServeNode | undefined) => {
  return parentNode?.id === "Settings";
};

const hidePaymentsOtherNode = (parentNode: SelfServeNode | undefined) => {
  return parentNode?.id === "Payments";
};

const hideOtherNode = (parentNode: SelfServeNode | undefined) => {
  return (
    hideFaireProgramsOtherNode(parentNode) ||
    hideVerifyAccountOtherNode(parentNode) ||
    hideSettingsOtherNode(parentNode) ||
    hidePaymentsOtherNode(parentNode)
  );
};

const shouldDisplayIconOnOtherNode = (
  parentNode: SelfServeNode | undefined
) => {
  return parentNode?.level === 0;
};

export const OtherIssueTopicCard: React.FC<IProps> = ({
  otherNode,
  selectedNode,
  parentNode,
  onClick,
  style,
}) => {
  if (!otherNode) {
    return null;
  }
  if (hideL1OtherNode(parentNode)) {
    return null;
  }

  if (hideOtherNode(parentNode)) {
    return null;
  }

  return (
    <IssueTopicCard
      text={otherNode.label!}
      isSelected={otherNode.id === selectedNode?.id}
      onClick={() => onClick(otherNode)}
      dataTestId={buildId(parentNode, otherNode)}
      icon={
        shouldDisplayIconOnOtherNode(parentNode) ? otherNode.icon : undefined
      }
      style={{ ...style }}
    />
  );
};

const buildId = (
  parentNode: SelfServeNode | undefined,
  otherNode: SelfServeNode
) => {
  return `self-serve-node-${otherNode.id}${parentNode?.id ?? "Root"}`;
};
